"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BarChart = _interopRequireDefault(require("@/components/Charts/BarChart.vue"));
var _vuex = require("vuex");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  name: 'Monitoring',
  bodyClass: 'monitoring-page',
  components: {
    BarChart: _BarChart.default
  },
  data: function data() {
    return {
      isLoadingChartIP: false,
      isLoadingChartPath: false,
      isLoadingChartErrors: false,
      isLoadingListErrors: false,
      chartDataPaths: {
        labels: [],
        datasets: [{
          label: 'Requisições',
          backgroundColor: '#36f',
          barThickness: 7,
          borderRadius: 3,
          data: []
        }]
      },
      dataChartIPs: {
        labels: [],
        datasets: [{
          label: 'Requisições',
          backgroundColor: '#36f',
          barThickness: 7,
          borderRadius: 3,
          data: []
        }]
      },
      chartDataErrors: {
        labels: [],
        datasets: [{
          label: 'Requisições',
          backgroundColor: [],
          barThickness: 7,
          borderRadius: 3,
          data: []
        }]
      },
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      data: [],
      total: 0,
      page: 1,
      perPage: 10,
      rows: []
    };
  },
  watch: {
    timeDash: function timeDash() {
      this.page = 1;
      this.loadAsyncData();
    }
  },
  created: function created() {
    this.getChartIPs();
    this.getChartPaths();
    this.getChartErrors();
    this.getErrors();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchChartIPs', 'fetchChartPaths', 'fetchChartErrors', 'fetchErrors'])), {}, {
    getChartIPs: function () {
      var _getChartIPs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var date, startDate, endDate, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.isLoadingChartIP = true;
              date = (0, _moment.default)().subtract(this.timeDash, 'days');
              startDate = date.format('YYYY-MM-DD');
              endDate = (0, _moment.default)().add(1, 'days').format('YYYY-MM-DD');
              _context.n = 1;
              return this.fetchChartIPs({
                params: {
                  startDate: startDate,
                  endDate: endDate
                }
              });
            case 1:
              data = _context.v;
              this.dataChartIPs.labels = data.data.labels.slice(0, 10);
              this.dataChartIPs.datasets[0].data = data.data.totelErrors.slice(0, 10);
              this.isLoadingChartIP = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getChartIPs() {
        return _getChartIPs.apply(this, arguments);
      }
      return getChartIPs;
    }(),
    getChartPaths: function () {
      var _getChartPaths = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var date, startDate, endDate, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.isLoadingChartPath = true;
              date = (0, _moment.default)().subtract(this.timeDash, 'days');
              startDate = date.format('YYYY-MM-DD');
              endDate = (0, _moment.default)().add(1, 'days').format('YYYY-MM-DD');
              _context2.n = 1;
              return this.fetchChartPaths({
                params: {
                  startDate: startDate,
                  endDate: endDate
                }
              });
            case 1:
              data = _context2.v;
              this.chartDataPaths.labels = data.data.labels.slice(0, 10);
              this.chartDataPaths.datasets[0].data = data.data.totelErrors.slice(0, 10);
              this.isLoadingChartPath = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getChartPaths() {
        return _getChartPaths.apply(this, arguments);
      }
      return getChartPaths;
    }(),
    getChartErrors: function () {
      var _getChartErrors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var date, startDate, endDate, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.isLoadingChartErrors = true;
              date = (0, _moment.default)().subtract(this.timeDash, 'days');
              startDate = date.format('YYYY-MM-DD');
              endDate = (0, _moment.default)().add(1, 'days').format('YYYY-MM-DD');
              _context3.n = 1;
              return this.fetchChartErrors({
                params: {
                  startDate: startDate,
                  endDate: endDate
                }
              });
            case 1:
              data = _context3.v;
              this.chartDataErrors.labels = data.data.labels;
              this.chartDataErrors.datasets[0].data = data.data.totelErrors;
              this.chartDataErrors.datasets[0].backgroundColor = this.getChartColors(data.data.labels);
              this.isLoadingChartErrors = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getChartErrors() {
        return _getChartErrors.apply(this, arguments);
      }
      return getChartErrors;
    }(),
    getErrors: function () {
      var _getErrors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _result$data, _result$data$metadata;
        var date, startDate, endDate, result, currentTotal;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.isLoadingListErrors = true;
              date = (0, _moment.default)().subtract(this.timeDash, 'days');
              startDate = date.format('YYYY-MM-DD');
              endDate = (0, _moment.default)().add(1, 'days').format('YYYY-MM-DD');
              _context4.n = 1;
              return this.fetchErrors({
                params: {
                  startDate: startDate,
                  endDate: endDate,
                  page: this.page,
                  limit: 10
                }
              });
            case 1:
              result = _context4.v;
              this.rows = result.data.data;
              currentTotal = ((_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$metadata = _result$data.metadata) === null || _result$data$metadata === void 0 ? void 0 : _result$data$metadata.totalRegisters) || 0; // limita o total de registros para no máximo 10 páginas
              if (currentTotal / this.perPage > 10) {
                currentTotal = this.perPage * 10;
              }
              this.total = currentTotal;
              this.isLoadingListErrors = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getErrors() {
        return _getErrors.apply(this, arguments);
      }
      return getErrors;
    }(),
    getColor: function getColor() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
      if (value <= 304) {
        return '#36f';
      }
      return '#D50000';
    },
    getChartColors: function getChartColors(labels) {
      var list = [];
      var _iterator = _createForOfIteratorHelper(labels),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var code = _step.value;
          var color = this.getColor(code);
          list.push(color);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return list;
    },
    onPageChange: function onPageChange(page) {
      this.page = page;
      this.getErrors();
    }
  })
};